import { ReviewEntity } from '@/entities/review.entity';
import { CsvExportProgressEventEntity } from '@/entities/csv-export-progress-event.entity';
import { AutoReplyProgressEventEntity } from '@/entities/auto-reply-progress-event.entity';
import { AiSelectedAnalysisProgressEventEntity } from '@/entities/ai-selected-analysis-progress-event.entity';
import { ReviewAiJobProgressEventEntity } from '@/entities/review-ai-job-progress-event.entity';
import { ReviewAnswerJobSkippedEvent } from '@/entities/review-answer-job-skipped-event.entity';
import { ReviewFeedItemChangedEventEntity } from '@/entities/review-feed-item-changed-event.entity';
import { ReviewSelectionReconcileCompletedEventEntity } from '@/entities/review-selection-reconcile-completed-event.entity';
import { ClientReviewsSyncDoneEventEntity } from '@/entities/client-reviews-sync-done-event.entity';

type SocketIoEventData = {
    reviewAnswerJobDone: { review: ReviewEntity; jobId: string };
    reviewAnswerJobSkipped: ReviewAnswerJobSkippedEvent;
    aiSelectedAnalysisProgress: AiSelectedAnalysisProgressEventEntity;
    reviewAiJobProgress: ReviewAiJobProgressEventEntity;
    autoReplyProgress: AutoReplyProgressEventEntity;
    reviewFeedItemChanged: ReviewFeedItemChangedEventEntity;
    clientReviewsSyncDone: ClientReviewsSyncDoneEventEntity;
    csvExportProgress: CsvExportProgressEventEntity;
    reviewSelectionReconcileCompleted: ReviewSelectionReconcileCompletedEventEntity;
};

export class SocketIoEvents {
    private _eventListeners: { [P in keyof SocketIoEventData]: ((data: SocketIoEventData[P]) => void)[] } = {
        reviewAnswerJobDone: [],
        reviewAnswerJobSkipped: [],
        aiSelectedAnalysisProgress: [],
        reviewAiJobProgress: [],
        autoReplyProgress: [],
        reviewFeedItemChanged: [],
        clientReviewsSyncDone: [],
        csvExportProgress: [],
        reviewSelectionReconcileCompleted: [],
    };

    emit<T extends keyof SocketIoEventData>(event: T, data: SocketIoEventData[T]) {
        this._eventListeners[event].forEach((e) => e(data));
    }

    on<T extends keyof SocketIoEventData>(event: T, callback: (typeof this._eventListeners)[T][number]) {
        this._eventListeners[event].push(callback);

        return () => this.off(event, callback);
    }

    off<T extends keyof SocketIoEventData>(event: T, callback: (typeof this._eventListeners)[T][number]) {
        const eventIndex = this._eventListeners[event].indexOf(callback);
        if (eventIndex === -1) return;

        this._eventListeners[event].splice(eventIndex, 1);
    }
}
